import React from 'react';

const TriangleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
    <path d="M5,0l5,10H0Z" style={{ fillRule: 'evenodd' }} />
  </svg>
);

export default TriangleIcon;
